import React from "react";

import "./style.scss";

interface Statistic {
  value: string | number;
  label: string;
}

interface Privileges {
  executiveOps: boolean;
  executiveOpsApprove: boolean;
}

interface WelcomeBannerProps {
  userName: string;
  roleDisplayName: string;
  organization?: string;
  statistics?: Statistic[];
  privileges?: Privileges;
}

const WelcomeBanner: React.FC<WelcomeBannerProps> = ({
  userName,
  roleDisplayName,
  organization,
  statistics = [],
  privileges,
}) => {
  return (
    <div className="welcome-banner bg-gradient-to-r from-purple-600 to-indigo-600 text-white">
      <div className="welcome-banner__content">
        <div className="welcome-banner__left">
          <h1 className="text-2xl font-bold">Welcome back, {userName}</h1>
          <div className="flex align-items-center gap-1 mt-1">
            <p className="text-purple-100">{roleDisplayName}</p>
            <p className="text-purple-100">
              {" •"} {organization}
            </p>
          </div>
        </div>
        <div className="flex items-center gap-6 flex-wrap">
          {statistics.length > 0 && (
            <>
              {statistics.map((stat, index) => (
                <div key={index} className="welcome-banner__statistic">
                  <div className="welcome-banner__statistic-value fs-20 fw-700">
                    {stat.value}
                  </div>
                  <div className="welcome-banner__statistic-label fs-14">
                    {stat.label}
                  </div>
                </div>
              ))}
            </>
          )}
          {privileges && (
            <div className="welcome-banner__privileges bg-white/15 backdrop-blur-sm rounded-xl px-4 py-4 border border-white/20 shrink-0">
              <h2 className="text-xs font-semibold uppercase tracking-wider mb-2 text-white">
                Your Privileges
              </h2>
              <ul className="space-y-2">
                <li className="flex items-center gap-2 text-white">
                  <span
                    className={`w-2 h-2 rounded-full shrink-0 ${
                      privileges.executiveOps === true
                        ? "bg-green-400"
                        : "bg-gray-400"
                    }`}
                  />
                  <span className="text-sm font-medium">
                    Exec Ops:{" "}
                    {privileges.executiveOps === true ? "Enabled" : "Disabled"}
                  </span>
                </li>
                <li className="flex items-center gap-2 text-white">
                  <span
                    className={`w-2 h-2 rounded-full shrink-0 ${
                      privileges.executiveOpsApprove === true
                        ? "bg-green-400"
                        : "bg-gray-400"
                    }`}
                  />
                  <span className="text-sm font-medium">
                    Approver:{" "}
                    {privileges.executiveOpsApprove === true
                      ? "Enabled"
                      : "Disabled"}
                  </span>
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WelcomeBanner;
